import { CanActivate, Router, ActivatedRouteSnapshot, ActivatedRoute } from '@angular/router';
import { AuthService } from './AuthService';
import { LocalStorageService } from 'angular-2-local-storage';
import * as _ from 'lodash';
import { Injectable } from '@angular/core';


@Injectable()
export class RoleGuardService implements CanActivate {
    constructor(public auth: AuthService,
        public router: Router,
        private localStorage: LocalStorageService) {

    }
    canActivate(route: ActivatedRouteSnapshot): boolean {
        const expectedRoles: string = route.data.expectedRoles;
        const userRoles: string[] = this.localStorage.get('user-roles');
        const data = this.router.config;

        if (!this.auth.isAuthenticated()) {
            this.router.navigate(['/signin']);
            return false;
        }

        if (_.intersection(userRoles, expectedRoles).length === 0) {
            this.router.navigate(['/admin/access-denied']);
            return false;
        }

        return true;
    }

    canManage(route: ActivatedRoute) {
        const expectedRoles: string = route.snapshot.data['canManage'];
        const userRoles: string[] = this.localStorage.get('user-roles');
        return _.intersection(userRoles, expectedRoles).length !== 0;
    }


}
